<div class="expert-text-div">
  <div class="expert-text-area-wrapper">
    <span [innerHtml]="text | removeIndentPipe | safeHtml" class="expert-text-span"></span>
  </div>
</div>